// Centralized SEO configuration for Barnum Événement
export const SITE_URL = "https://www.barnum-evenement.fr";
export const SITE_NAME = "Barnum Événement";
export const DEFAULT_IMAGE =
  "https://customer-assets.emergentagent.com/job_tentopia-events/artifacts/kabgc5k3_6x12%20devant%20chateau.jpg";

export const DEFAULT_TITLE =
  "Location de Barnum, Chapiteaux et Tentes en Normandie | Barnum Événement";
export const DEFAULT_DESCRIPTION =
  "Barnum Événement au Havre : location de matériel événementiel (barnums, chapiteaux, tables, chaises, planchers, vaisselle pro) en Normandie. Mariage, réception, événement pro. Livraison et installation.";

// Exact pathname -> metadata
export const ROUTE_SEO = {
  "/": { title: DEFAULT_TITLE, description: DEFAULT_DESCRIPTION },
  "/catalogue": {
    title: "Catalogue de location – Barnums, mobilier & vaisselle | Barnum Événement",
    description:
      "Découvrez notre catalogue de location : barnums, chapiteaux, tentes de réception, tables, chaises, planchers, vaisselle et accessoires pour vos événements en Normandie.",
  },
  "/services": {
    title: "Nos services de location événementielle | Barnum Événement",
    description:
      "Location, livraison et installation de matériel événementiel en Normandie. Barnum Événement vous accompagne pour mariages, réceptions et événements professionnels.",
  },
  "/realisations": {
    title: "Nos réalisations – Événements en Normandie | Barnum Événement",
    description:
      "Découvrez nos réalisations : mariages, réceptions et événements équipés par Barnum Événement au Havre et en Normandie.",
  },
  "/galerie": {
    title: "Galerie photos de nos installations | Barnum Événement",
    description:
      "Galerie photos de nos barnums et chapiteaux installés lors d'événements en Normandie.",
    canonical: "/realisations",
  },
  "/faq": {
    title: "Questions fréquentes sur la location | Barnum Événement",
    description:
      "Délais de livraison, montage, caution, zones desservies : retrouvez les réponses aux questions fréquentes sur la location de matériel événementiel.",
  },
  "/blog": {
    title: "Conseils événementiels & actualités | Barnum Événement",
    description:
      "Conseils et idées pour organiser vos événements en Normandie : mariages, réceptions, choix du barnum et aménagement.",
  },
  "/conseils-evenementiels": {
    title: "Conseils pour organiser votre événement | Barnum Événement",
    description:
      "Nos conseils pratiques pour réussir l'organisation de votre événement en Normandie avec le bon matériel de location.",
    canonical: "/blog",
  },
  "/a-propos": {
    title: "À propos de Barnum Événement – Location en Normandie",
    description:
      "Barnum Événement, votre spécialiste de la location de barnums et chapiteaux au Havre et en Normandie. Découvrez notre histoire et nos engagements.",
  },
  "/devis": {
    title: "Demande de devis gratuit – Location événementielle | Barnum Événement",
    description:
      "Demandez votre devis gratuit en ligne pour la location de barnum, chapiteau et matériel événementiel en Normandie. Réponse rapide et personnalisée.",
  },
  "/mentions-legales": {
    title: "Mentions légales | Barnum Événement",
    description: "Mentions légales du site Barnum Événement.",
  },
  "/confidentialite": {
    title: "Politique de confidentialité | Barnum Événement",
    description: "Politique de confidentialité et gestion des données personnelles de Barnum Événement.",
  },
  "/conditions-generales-location": {
    title: "Conditions générales de location | Barnum Événement",
    description: "Conditions générales de location (CGL) de Barnum Événement.",
  },
};

const capitalize = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);
const humanize = (slug) =>
  decodeURIComponent(slug || "")
    .replace(/-/g, " ")
    .split(" ")
    .map(capitalize)
    .join(" ");

// Resolve SEO metadata for any pathname (handles dynamic routes)
export function resolveSeo(pathname) {
  let path = pathname || "/";
  if (path.length > 1 && path.endsWith("/")) path = path.slice(0, -1);

  if (ROUTE_SEO[path]) {
    const cfg = ROUTE_SEO[path];
    return {
      title: cfg.title,
      description: cfg.description,
      canonicalPath: cfg.canonical || path,
      noindex: false,
    };
  }

  if (path === "/admin") {
    return {
      title: "Administration | Barnum Événement",
      description: "",
      canonicalPath: path,
      noindex: true,
    };
  }

  if (path.startsWith("/location/")) {
    const slug = path.split("/")[2];
    const at = slug === "le-havre" ? "au Havre" : `à ${humanize(slug)}`;
    return {
      title: `Location de barnum et chapiteau ${at} | Barnum Événement`,
      description: `Location de barnums, chapiteaux et matériel événementiel ${at} et dans toute la Normandie. Livraison et installation par Barnum Événement.`,
      canonicalPath: path,
      noindex: false,
    };
  }

  if (path.startsWith("/catalogue/")) {
    const segs = path.split("/").filter(Boolean);
    const label = humanize(segs[segs.length - 1]);
    return {
      title: `${label} en location | Barnum Événement`,
      description: `Location de ${label.toLowerCase()} pour vos événements en Normandie. Découvrez les tarifs et demandez votre devis chez Barnum Événement.`,
      canonicalPath: path,
      noindex: false,
    };
  }

  if (path.startsWith("/blog/")) {
    return {
      title: "Article – Conseils événementiels | Barnum Événement",
      description: DEFAULT_DESCRIPTION,
      canonicalPath: path,
      noindex: false,
    };
  }

  return {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
    canonicalPath: path,
    noindex: false,
  };
}
